@if (isVisible()) {
      <!-- GAP-FE-H012 round-12 · Raised to z-popover (popover layer)
           so the confirmation dialog stays above the modal z-modal
           layer. Otherwise nested confirmations (Bulk Validate /
           Bulk Delete triggered from inside <ui-modal>) render
           BEHIND the modal and the operator can't approve/reject. -->
      <div class="fixed inset-0 z-popover flex items-center justify-center">
        <!-- Backdrop -->
        <div
          class="absolute inset-0 bg-black/60 backdrop-blur-sm"
          [class.cursor-pointer]="dismissableMask()"
          (click)="onMaskClick()">
        </div>

        <!-- Dialog -->
        <div
          class="relative z-10 w-full max-w-md mx-4 animate-in fade-in zoom-in-95 duration-200"
          role="alertdialog"
          [attr.aria-modal]="true"
          [attr.aria-labelledby]="'confirm-dialog-header'"
          [attr.aria-describedby]="'confirm-dialog-message'">
          <div [class]="dialogClasses()">
            <!-- Header -->
            @if (header()) {
              <div class="flex items-center gap-3 p-4 border-b border-bb-border">
                @if (icon(); as iconName) {
                  <span [class]="iconClasses()">
                    <ui-icon [name]="iconName" size="md"></ui-icon>
                  </span>
                }
                <h2
                  id="confirm-dialog-header"
                  class="text-lg font-semibold text-bb-text-primary">
                  {{ header() }}
                </h2>
              </div>
            }

            <!-- Content -->
            <div class="p-6">
              @if (!header() && icon(); as iconName) {
                <div class="flex justify-center mb-4">
                  <span [class]="largeIconClasses()">
                    <ui-icon [name]="iconName" size="xl"></ui-icon>
                  </span>
                </div>
              }

              <p
                id="confirm-dialog-message"
                class="text-bb-text-secondary text-center"
                [class.text-left]="header()">
                {{ message() }}
              </p>
            </div>

            <!-- Footer -->
            <div class="flex justify-end gap-3 p-4 border-t border-bb-border">
              @if (rejectVisible()) {
                <app-button
                  [variant]="'outline'"
                  (click)="onReject()">
                  {{ rejectLabel() }}
                </app-button>
              }
              @if (acceptVisible()) {
                <app-button
                  [variant]="acceptVariant()"
                  [autofocus]="defaultFocus() === 'accept'"
                  (click)="onAccept()">
                  {{ acceptLabel() }}
                </app-button>
              }
            </div>
          </div>
        </div>
      </div>
    }
